import type Store from '@ember-data/store';
import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import FundsService from 'donor-elf-web/services/funds-service';
import type NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import type SessionService from 'ember-simple-auth/services/session';

export default class FundsIndexRoute extends Route {
  @service declare fundsService: FundsService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare session: SessionService;
  @service declare storeCache: Store;

  afterModel() {
    this.navbarSettings.topNavbarComponent = 'top-navbar-funds-index';
  }

  async beforeModel(transition: Transition) {
    await this.session.requireAuthentication(transition, 'login');
    this.navbarSettings.title = 'Select a Fund';
  }

  willTransition = (transition: Transition) => {
    const intentName = transition.targetName || '';

    if (intentName.length > 0 && intentName.indexOf('funds.index') !== 0) {
      this.navbarSettings.topNavbarComponent = '';
    }

    if (intentName === 'funds.fund') {
      // if transitioning to the fund, then set the title early as the data
      // is being retrieved
      this.navbarSettings.title = 'Dashboard';
    }
  };
}
